import * as yup from 'yup';
export const RenewEnrollmentFormValidation = yup.object().shape({
  // isForeign: yup.boolean().default(false),
  user: yup.object().shape({
    name: yup.string().required('Nome é obrigatório'),
    isForeign: yup.boolean().default(false),
    bi: yup.string().required("Campo obrigatório")
      .when('isForeign', {
        is: true,
        then: schema => schema.required("Campo obrigatório"),
        otherwise: schema => schema.required('Campo obrigatório')
          .test('is-valid-document', 'Número do documento inválido', (value) => {
            if (!value) return false;

            // Conjuntos de regex para os documentos suportados
            const documentRegexes = [
              /^\d{12}[A-Za-z]$/, // BI: 12 dígitos seguidos de uma letra
              /^\d{12}$/, // BISlip: Apenas 12 dígitos
              /^[A-Z]{2}\d{7}$/, // DrivingLicense: 2 letras seguidas de 7 dígitos
              /^[A-Z]{2}\d{8}$/, // DrivingLicense: 2 letras seguidas de 8 dígitos
              /^[A-Z]{2}\d{9}$/, // DrivingLicense: 2 letras seguidas de 9 dígitos
              /^\d{13}$/, // VoterCard: 13 dígitos
            ];

            // O número deve passar em pelo menos um dos padrões
            return documentRegexes.some((regex) => regex.test(value));
          })
        //  .matches(/^\d{12}[A-Za-z]$/, 'Deve conter 12 dígitos seguidos de 1 letra')
        ,
      })
    ,
    nuit: yup
      .string()
      .optional()
      .matches(/^\d{9}$/, {
        message: "Deve ter 9 digitos",
        excludeEmptyString: true,
      })
    //  .when('isForeign', {
    //    is: true,
    //    then: schema => schema.nullable().optional(),
    //    otherwise: schema => schema.required('Nuit é obrigatório').matches(/^\d{9}$/, 'Deve ter 9 dígitos'),
    //  })
    ,
    email: yup.string().email('Email inválido'),
    phoneNumber: yup.string()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, 'Número de telemóvel inválido')
      .required('Número de telemóvel é obrigatório'),
    secondaryPhoneNumber: yup.string()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, 'Número de telemóvel inválido')
      .optional(),
    gender: yup.string().oneOf(['M', 'F'] as const, 'Gênero inválido').required('Gênero é obrigatório'),
    dateOfBirth: yup.string().required('Data de nascimento é obrigatória')
      .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
      .test('is-past', 'Data de nascimento não pode ser no futuro',
        (value) => !value || new Date(value) <= new Date()),
    userName: yup.string(),
  }),
  documents: yup.array().of(
    yup.object().shape({
      id: yup.string().required('O ID do documento é obrigatório'),
      file: yup.mixed<File>()
        .required('O ficheiro é obrigatório')
        .test('is-file', 'Tipo de ficheiro inválido', (value): value is File => value instanceof File)
    })
  ).defined(),
  enrollment: yup.object().shape({
    idCourse: yup.string().required("Selecione o curso"),
  }),
  idFaculty: yup.string().required("Unidade orgânica é obrigatória"),
  idDepartament: yup.string().required('Departamento é obrigatório'),
  idPlan: yup.string().required('Plano de curso é obrigatório'),
  subscribeStudent: yup.boolean().default(true),
  isInternStudent: yup.boolean().default(false),
  schoolCode: yup.string()
    .required("Preencha o código do estudante"),
  year: yup.number().typeError("Deve ser um número").notOneOf([1], 'Deve ser maior que 1')
    .positive('Deve ser maior que zero'),
  semester: yup.number().typeError("Deve ser um número")
    .positive('Deve ser maior que zero')
    .oneOf([1, 2], 'Semestre deve ser 1 ou 2')
  ,
});